export enum ExecType {
  param = 0,
  command = 1,
  resource = 2
}
